import { render } from "./IPGrid.vue?vue&type=template&id=084a28ec"
import script from "./IPGrid.vue?vue&type=script&lang=js"
export * from "./IPGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__